import React, { useState, useEffect, useRef, useCallback } from "react";
import _ from "lodash";
import { showSpinner, closeSpinner, modal, alert } from "../modules/Dialogs";
import { sessionExpired } from "../config/GeneralConfig";
import { toScreen } from "../modules/Routing";
import PropTypes from "prop-types";
import withNavigate from "./withNavigate";
import moment from "moment-timezone";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Pagination from "./Pagination";
import RefundDetails from "./RefundDetails";
import DriverPenalty from "./DriverPenalty";
import {
  getretrieveDriverPenaltiesIssueResolutions,
  getretrieveRefundIssueResolutions,
} from "../modules/IssueAndResolution";
import { getConversation } from "../modules/MessageManager";

const IssuesResolution = ({ userDetails, navigate }) => {
  const [state, setState] = React.useState({
    right: false,
  });
  const [currentView, setCurrentView] = useState(null);
  const [selectedIssueResolution, setSelectedIssueResolution] = useState(null);
  const [statusFilter, setStatusFilter] = useState("allStatus");
  const [searchValue, setSearchValue] = useState(null);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState(
    window.history.state?.usr?.selectedFilter ?? "all"
  );
  const [conversationDetails, setConversationDetails] = useState([]);
  const [count, setCount] = useState(0);
  const [jobTypeFilter, setJobTypeFilter] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [cancelledStartDate, setCancelledStartDate] = useState(null);
  const [cancelledEndDate, setCancelledEndDate] = useState(null);
  const [scheduledStartDate, setScheduledStartDate] = useState(null);
  const [scheduledEndDate, setScheduledEndDate] = useState(null);
  const [pageSize, setPageSize] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [inputValue, setInputValue] = useState(1);
  const [sort, setSort] = useState("statusSorter=-1");
  const [activeTab, setActiveTab] = useState("refund");
  const [activeFilters, setActiveFilters] = useState({
    refund: null,
    driverPenalties: null,
  });
  const [issueResolutions, setIssueResolutions] = useState([]);
  const [selectedCheckbox, setSelectedCheckbox] = useState([]);

  const getConversations = (convPropsArgument) => {
    const requasterShortId = convPropsArgument?.userDetails?.shortId || "Admin";

    const queryParams = {
      receiverShortId: convPropsArgument?.driverDetails?.shortId,
      receiverId: convPropsArgument?.driverDetails?._id,
      requasterShortId,
      page: 1,
      pageSize: 100000,
    };

    showSpinner();
    getConversation(queryParams, getConversation_done, userDetails?.jwttoken);
  };

  const getConversation_done = (resStatus, responseString, resJson) => {
    closeSpinner();

    if (resStatus === 401) {
      return modal(responseString, "401 Unauthorized", () =>
        window.history.back()
      );
    }

    if (resStatus === 400) {
      return modal(responseString, "Something went wrong!", () =>
        window.history.back()
      );
    }

    if (resStatus === 200) {
      setConversationDetails(resJson?.data);
    }
  };

  // Toggle drawer function
  const toggleDrawer =
    (anchor, open, view = null, issueResolution = null) =>
      (event) => {
        // if (
        //   event.type === "keydown" &&
        //   (event.key === "Tab" || event.key === "Shift")
        // ) {
        //   return;
        // }

        setState({ ...state, [anchor]: open });

        if (open) {
          setCurrentView(view);
          if (issueResolution) {
            setSelectedIssueResolution(issueResolution);
          } else {
            setSelectedIssueResolution(null);
          }
          getConversations(issueResolution);
        }
      };

  useEffect(() => {
    setInputValue(page);
  }, [page]);

  const searchIssueAndResolution = useCallback(() => {
    setSearch(searchValue);
    setFilter(searchValue === "" ? "all" : null);
    setPage(1);
  }, [searchValue]);

  const sortIssueResolutions = (event, field) => {
    if (event) event.preventDefault();

    const sortFields = {
      firstnameSorter: { asc: "firstnameSorter=1", desc: "firstnameSorter=-1" },
      reasonSorter: { asc: "reasonSorter=1", desc: "reasonSorter=-1" },
      cancelledOnSorter: {
        asc: "cancelledOnSorter=1",
        desc: "cancelledOnSorter=-1",
      },
      cancellationRateSorter: {
        asc: "cancellationRateSorter=1",
        desc: "cancellationRateSorter=-1",
      },
      job: { asc: "job=1", desc: "job=-1" },
      bookedFor: { asc: "bookedFor=1", desc: "bookedFor=-1" },
      bookedOnSorter: { asc: "bookedOnSorter=1", desc: "bookedOnSorter=-1" },
      scheduledForSorter: {
        asc: "scheduledForSorter=1",
        desc: "scheduledForSorter=-1",
      },
      amountSorter: { asc: "amountSorter=1", desc: "amountSorter=-1" },
      requestedOnSorter: { asc: "requestedOnSorter=1", desc: "requestedOnSorter=-1" },
      statusSorter: { asc: "statusSorter=1", desc: "statusSorter=-1" },
      startDate: { asc: "startDate=1", desc: "startDate=-1" },
      uses: { asc: "uses=1", desc: "uses=-1" },
      endDate: { asc: "endDate=1", desc: "endDate=-1" },
    };

    const currentSort = sortFields[field];
    if (!currentSort) return;

    const newSort =
      sort === currentSort.asc ? currentSort.desc : currentSort.asc;

    setSort(newSort);
    setPage(1);
  };

  const formatDateForAPI = (date) => {
    return date ? moment(date).format("YYYY-MM-DD") : null;
  };

  const getRefundIssueResolutions = () => {
    const dateLowerRange = formatDateForAPI(startDate);
    const dateUpperRange = formatDateForAPI(endDate);

    if ((startDate && !endDate) || (!startDate && endDate)) {
      console.warn("Both start and end dates are required.");
      return;
    }

    const queryParams = {
      search,
      jobType: jobTypeFilter !== "all" ? jobTypeFilter : undefined,
      refund: statusFilter !== "allStatus" ? statusFilter : undefined,
      dateLowerRange,
      dateUpperRange,
      filter,
      sort,
      page,
      limit: pageSize, // Add limit to the query params
    };
    // Remove undefined values
    Object.keys(queryParams).forEach(
      (key) => queryParams[key] === undefined && delete queryParams[key]
    );

    showSpinner();
    getretrieveRefundIssueResolutions(
      queryParams,
      getRefundIssueResolutions_done,
      userDetails.jwttoken
    );
  };

  const getRefundIssueResolutions_done = (
    resStatus,
    responseString,
    resJson
  ) => {
    closeSpinner();

    if (resStatus === 401) {
      modal(sessionExpired);
      toScreen(false, navigate, "/logout");
    } else if (resStatus === "400") {
      setIssueResolutions([]);
      alert(responseString);
    } else if (resStatus === 200) {
      setTotalPages(Math.ceil(resJson?.totalRecords / pageSize));
      setIssueResolutions(resJson?.data || []);
      setCount(resJson);

      // Update filter counts if available
      if (resJson?.filterCounts) {
        setFilterCount(resJson.filterCounts);
      }
    }
  };

  // Enhanced API call for driver penalties
  const getDriverPenaltiesIssueResolutions = () => {
    const dateLowerRange = formatDateForAPI(cancelledStartDate);
    const dateUpperRange = formatDateForAPI(cancelledEndDate);
    const scheduledDateLowerRange = formatDateForAPI(scheduledStartDate);
    const scheduledDateUpperRange = formatDateForAPI(scheduledEndDate);

    if (
      (cancelledStartDate && !cancelledEndDate) ||
      (!cancelledStartDate && cancelledEndDate)
    ) {
      console.warn("Both cancelled start and end dates are required.");
      return;
    }

    if (
      (scheduledStartDate && !scheduledEndDate) ||
      (!scheduledStartDate && scheduledEndDate)
    ) {
      console.warn("Both scheduled start and end dates are required.");
      return;
    }
    const queryParams = {
      search,
      jobType: jobTypeFilter !== "all" ? jobTypeFilter : undefined,
      penalty: statusFilter !== "allStatus" ? statusFilter : undefined,
      dateLowerRange,
      dateUpperRange,
      scheduledDateLowerRange,
      scheduledDateUpperRange,
      filter,
      sort,
      page,
      limit: pageSize,
    };

    Object.keys(queryParams).forEach(
      (key) => queryParams[key] === undefined && delete queryParams[key]
    );

    showSpinner();
    getretrieveDriverPenaltiesIssueResolutions(
      queryParams,
      getDriverPenaltiesIssueResolutions_done,
      userDetails.jwttoken
    );
  };

  const getDriverPenaltiesIssueResolutions_done = (
    resStatus,
    responseString,
    resJson
  ) => {
    closeSpinner();

    if (resStatus === 401) {
      modal(sessionExpired);
      toScreen(false, navigate, "/logout");
    } else if (resStatus === "400") {
      setIssueResolutions([]);
      alert(responseString);
    } else if (resStatus === 200) {
      setTotalPages(Math.ceil(resJson?.totalRecords / pageSize));
      setIssueResolutions(resJson?.data || []);
      setCount(resJson);

      // Update filter counts if available
      if (resJson?.filterCounts) {
        setFilterCount(resJson.filterCounts);
      }
    }
  };

  // Fetch data when filters change
  useEffect(() => {
    if (activeTab === "refund") {
      getRefundIssueResolutions();
    } else if (activeTab === "driverPenalties") {
      getDriverPenaltiesIssueResolutions();
    }
  }, [activeTab, search, sort, page, pageSize, statusFilter]);

  // Reset tab-specific filters when switching tabs
  useEffect(() => {
    setSearchValue("");
    setSearch("");
    setStatusFilter("allStatus");
    setPage(1);
    setSort("statusSorter=-1");
  }, [activeTab]);

  const renderIssueResolution = (issueResolution, index) => {
    const statusMap = {
      exempt: {
        label: "Waived",
        badge: "badge-secondary",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-circle-off lucide-icon h-3 w-3"
          >
            <path d="m2 2 20 20"></path>
            <path d="M8.35 2.69A10 10 0 0 1 21.3 15.65"></path>
            <path d="M19.08 19.08A10 10 0 1 1 4.92 4.92"></path>
          </svg>
        ),
      },
      "not exempt": {
        label: "Applied",
        badge: "badge-danger",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-circle-arrow-up lucide-icon h-3 w-3"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <path d="m16 12-4-4-4 4"></path>
            <path d="M12 16V8"></path>
          </svg>
        ),
      },
      pending: {
        label: "Pending",
        badge: "badge-warning",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-clock h-3 w-3"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        ),
      },
      approved: {
        label: "Approved",
        badge: "badge-success",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-check h-3 w-3"
          >
            <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
            <path d="m9 11 3 3L22 4"></path>
          </svg>
        ),
      },
      rejected: {
        label: "Rejected",
        badge: "badge-danger",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-x h-3 w-3"
          >
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        ),
      },
    };

    const status = issueResolution?.status || issueResolution?.refund;
    const statusData = statusMap[status?.toLowerCase()];

    const cancellationRatePercentage =
      (issueResolution?.driverDetails?.cancellationRate /
        issueResolution?.driverDetails?.bookings) *
      100;

    const getJobTypeDisplay = (jobType) => {
      const jobTypeMap = {
        getitems: "Get items",
        housemove: "House move",
        senditems: "Send items",
        wasteDisposal: "Waste Disposal",
      };
      return jobTypeMap[jobType] || jobType;
    };

    const columnConfigData =
      activeTab === "refund" ? (
        <div className={`c-list-entry align-items-center`} key={index}>
          <div className="c-list-entry__mavname">
            <b>{issueResolution?.userDetails?.firstname}</b>
          </div>
          <div className="c-list-entry__rating">
            <span>
              {" "}
              {getJobTypeDisplay(issueResolution?.jobDetails?.jobType)}
            </span>
            <br />
            <span>{issueResolution?.jobDetails?.shortId}</span>
          </div>{" "}
          <div className="c-list-entry__rating">
            <span className="u-before-icon text-capitalize">
              <strong> &nbsp;&nbsp; £</strong>
              {(issueResolution?.jobDetails?.bookedFor)/100}
            </span>
          </div>
          <div className="c-list-entry__location">
            {issueResolution?.cancellationDetails?.reason}
          </div>
          <div className="c-list-entry__status">
            {statusData && (
              <span className={`badge text-capitalize ${statusData?.badge}`}>
                {statusData?.icon}
                <span className="ml-1">{statusData?.label}</span>
              </span>
            )}
          </div>
          <div className="c-list-entry__startDate">
            {moment(issueResolution?.cancellationDetails?.cancelledOn).format(
              "DD-MM-YYYY"
            )}{" "}
            <br />
            {moment(issueResolution?.cancellationDetails?.cancelledOn).format(
              "HH:mm "
            )}
          </div>
          <div className="c-list-entry__uses">
            {["right"].map((anchor) => (
              <React.Fragment key={anchor}>
                <Button
                  className="btn btn-sm btn-secondary"
                  onClick={toggleDrawer(
                    anchor,
                    true,
                    "details",
                    issueResolution
                  )}
                >
                  Details
                </Button>
                <Drawer
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}
                  ModalProps={{
                    BackdropProps: {
                      style: { backgroundColor: "rgba(0, 0, 0, 0.1)" },
                    },
                  }}
                  sx={{
                    boxShadow: "none",
                    "& .MuiDrawer-paper": { boxShadow: "none" },
                  }}
                >
                  {RefundDetailsPage(anchor)}
                </Drawer>
              </React.Fragment>
            ))}
          </div>
        </div>
      ) : (
        <div className={`c-list-entry align-items-center`} key={index}>
          <div className="c-list-entry__reason text-capitalize">
            {issueResolution?.driverDetails?.firstname}
          </div>
          <div className="c-list-entry__mavname">
            {issueResolution?.driverDetails?.cancellationRate} /
            {issueResolution?.driverDetails?.bookings} bookings <br />
            <span className="text-xs">
              {cancellationRatePercentage.toFixed(2)}%
            </span>
          </div>
          <div className="c-list-entry__mavname">
            <span className="u-before-icon text-capitalize">
              &nbsp;&nbsp;{issueResolution?.cancellationDetails?.reason}
            </span>
          </div>
          <div className="c-list-entry__rating">
            {moment(issueResolution?.cancellationDetails?.cancelledOn).format(
              "DD-MM-YYYY"
            )}{" "}
            <br />
            {moment(issueResolution?.cancellationDetails?.cancelledOn).format(
              "HH:mm A"
            )}{" "}
          </div>
          <div className="c-list-entry__reviews">
            {statusData && (
              <span className={`badge ${statusData?.badge}`}>
                {statusData?.icon}
                <span className="ml-1">{statusData?.label}</span>
              </span>
            )}
          </div>
          <div className="c-list-entry__reviews">
            <span>  {getJobTypeDisplay(
              issueResolution?.jobDetails?.jobType
            )}</span> <br />{" "}
            <span>{issueResolution?.jobDetails?.shortId}</span>
          </div>


          <div className="c-list-entry__jobdate">

            {issueResolution?.cancellationDetails?.wasJobPaid === true ? (
              <div >
                <strong> &nbsp;&nbsp; £</strong>
                {(issueResolution?.jobDetails?.bookedFor)/100 || 0}
              </div>
            ) : (<div>
              -
            </div>
            )}
          </div>

          <div className="c-list-entry__jobdate">
            {
              issueResolution?.cancellationDetails?.wasJobPaid === true ? (
                <div>


                  {moment(issueResolution?.jobDetails?.bookedOn).format("DD-MM-YYYY")}{" "}
                  <br />
                  {moment(issueResolution?.jobDetails?.bookedOn).format("HH:mm")} </div>
              ) : (<div>-</div>)

            }

          </div>
          <div className="c-list-entry__jobdate">
            {moment(issueResolution?.jobDetails?.scheduledFor).format(
              "DD-MM-YYYY"
            )}{" "}
            <br />
            {moment(issueResolution?.jobDetails?.scheduledFor).format("HH:mm")}
          </div>

          <div className="c-list-entry__uses ">
            {["right"].map((anchor) => (
              <React.Fragment key={anchor}>
                <Button
                  className="btn btn-sm btn-secondary"
                  onClick={toggleDrawer(
                    anchor,
                    true,
                    "details",
                    issueResolution
                  )}
                >
                  Details
                </Button>
                <Drawer
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}
                  ModalProps={{
                    BackdropProps: {
                      style: { backgroundColor: "rgba(0, 0, 0, 0.1)" },
                    },
                  }}
                  sx={{
                    boxShadow: "none",
                    "& .MuiDrawer-paper": { boxShadow: "none" },
                  }}
                >
                  {DriverPenaltyPage(anchor)}
                </Drawer>
              </React.Fragment>
            ))}
          </div>
        </div>
      );

    return <div>{columnConfigData}</div>;
  };

  const RefundDetailsPage = (anchor) => (
    <Box
      sx={{ width: 600 }}
      role="presentation"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <RefundDetails
        view={currentView}
        issueResolution={selectedIssueResolution}
        onClose={toggleDrawer(anchor, false)}
        selectedIssueResolution={selectedIssueResolution}
        userDetails={userDetails}
        conversationDetails={conversationDetails}
        theCallBackFunc={getRefundIssueResolutions}
        getConversations={getConversations}
      />
    </Box>
  );

  const DriverPenaltyPage = (anchor) => (
    <Box
      sx={{ width: 600 }}
      role="presentation"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <DriverPenalty
        view={currentView}
        issueResolution={selectedIssueResolution}
        onClose={toggleDrawer(anchor, false)}
        selectedIssueResolution={selectedIssueResolution}
        userDetails={userDetails}
        theCallBackFunc={getDriverPenaltiesIssueResolutions}
        conversationDetails={conversationDetails}
        getConversations={getConversations}
      />
    </Box>
  );

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const inputValue = type === "checkbox" ? checked : value;

    if (name === "search") {
      setSearchValue(inputValue);
      // Auto-search with debounce could be added here
    } else if (name === "jobType") {
      setJobTypeFilter(inputValue);
    } else if (name === "filter") {
      setSearch("");
      setSearchValue(null);
      setFilter(inputValue);
      setPage(1);
    } else if (name === "penalty") {
      setStatusFilter(inputValue);
    } else if (name === "refund") {
      setStatusFilter(inputValue);
    }
  };

  const getSortClass = useCallback(
    (key) => {
      if (sort === `${key}=1`) {
        return "c-list-filter__button c-list-filter__button--icon-up";
      } else if (sort === `${key}=-1`) {
        return "c-list-filter__button c-list-filter__button--icon-down";
      }
      return "c-list-filter__button c-list-filter__button--faded";
    },
    [sort]
  );

  const getJobTypeDisplay = (jobType) => {
    const jobTypeMap = {
      getitems: "Get items",
      housemove: "House move",
      senditems: "Send items",
      wasteDisposal: "Waste Disposal",
    };
    return jobTypeMap[jobType] || jobType;
  };

  // Column headers based on active tab
  const renderColumnHeaders = () => {
    const columnConfig =
      activeTab === "refund" ? (
        <div className="c-list-entry c-list-entry__header align-items-center">
          <div className="c-list-entry__mavname c-list-filter">
            <button
              className={getSortClass("firstnameSorter")}
              onClick={(e) => sortIssueResolutions(e, "firstnameSorter")}
            >
              Client
            </button>
          </div>
          <div className="c-list-entry__rating c-list-filter">
            <button
              className={getSortClass("job")}
            // onClick={(e) => sortIssueResolutions(e, "job")}
            >
              Job
            </button>
          </div>
          <div className="c-list-entry__rating c-list-filter">
            <button
              className={getSortClass("amountSorter")}
              onClick={(e) => sortIssueResolutions(e, "amountSorter")}
            >
              Amount
            </button>
          </div>
          <div className="c-list-entry__location c-list-filter">
            <button
              className={getSortClass("reasonSorter")}
              onClick={(e) => sortIssueResolutions(e, "reasonSorter")}
            >
              Reason
            </button>
          </div>
          <div className="c-list-entry__status c-list-filter">
            <button
              className={getSortClass("statusSorter")}
              onClick={(e) => sortIssueResolutions(e, "statusSorter")}
            >
              Status
            </button>
          </div>
          <div className="c-list-entry__startDate c-list-filter">
            <button
              className={getSortClass("requestedOnSorter")}
              onClick={(e) => sortIssueResolutions(e, "requestedOnSorter")}
            >
              Requested On
            </button>
          </div>
          <div className="c-list-entry__uses c-list-filter">
            <button className="c-list-filter__button--faded">Actions</button>
          </div>
        </div>
      ) : (
        <div className="c-list-entry c-list-entry__header align-items-center">
          <div className="c-list-entry__reason c-list-filter">
            <button
              className={getSortClass("firstnameSorter")}
              onClick={(e) => sortIssueResolutions(e, "firstnameSorter")}
            >
              Driver
            </button>
          </div>
          <div className="c-list-entry__mavname c-list-filter">
            <button
              className={getSortClass("cancellationRateSorter")}
              onClick={(e) => sortIssueResolutions(e, "cancellationRateSorter")}
            >
              Cancellations
            </button>
          </div>
          <div className="c-list-entry__mavname c-list-filter">
            <button
              className={getSortClass("reasonSorter")}
              onClick={(e) => sortIssueResolutions(e, "reasonSorter")}
            >
              Reason
            </button>
          </div>
          <div className="c-list-entry__rating c-list-filter">
            <button
              className={getSortClass("cancelledOnSorter")}
              onClick={(e) => sortIssueResolutions(e, "cancelledOnSorter")}
            >
              Cancelled On
            </button>
          </div>
          <div className="c-list-entry__reviews c-list-filter">
            <button
              className={getSortClass("statusSorter")}
              onClick={(e) => sortIssueResolutions(e, "statusSorter")}
            >
              Status
            </button>
          </div>
          <div className="c-list-entry__reviews c-list-filter">
            <button
              className={getSortClass("job")}
            // onClick={(e) => sortIssueResolutions(e, "job")}
            >
              Job
            </button>
          </div>
          <div className="c-list-entry__jobdate c-list-filter">
            <button
              className={getSortClass("bookedFor")}
              onClick={(e) => sortIssueResolutions(e, "bookedFor")}
            >
              Booked For
            </button>
          </div>
          <div className="c-list-entry__jobdate c-list-filter">
            <button
              className={getSortClass("bookedOnSorter")}
              onClick={(e) => sortIssueResolutions(e, "bookedOnSorter")}
            >
              Booked On
            </button>
          </div>
          <div className="c-list-entry__jobdate c-list-filter">
            <button
              className={getSortClass("scheduledForSorter")}
              onClick={(e) => sortIssueResolutions(e, "scheduledForSorter")}
            >
              Scheduled for
            </button>
          </div>
          <div className="c-list-entry__uses c-list-filter">
            <button className="c-list-filter__button--faded">Actions</button>
          </div>
        </div>
      );

    return <div>{columnConfig}</div>;
  };

  const renderFilterOptions = () => {
    if (activeTab === "refund") {
      return (
        <div className="l-col-100 u-padding-top-0 u-padding-bottom-0">
          <div className="filter-bar">
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="refund_all"
                name="refund"
                value="allStatus"
                onChange={handleInputChange}
                checked={statusFilter === "allStatus"}
              />
              <label htmlFor="refund_all">All</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="refund_pending"
                name="refund"
                value="pending"
                onChange={handleInputChange}
                checked={statusFilter === "pending"}
              />
              <label htmlFor="refund_pending">Pending</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="refund_approved"
                name="refund"
                value="approved"
                onChange={handleInputChange}
                checked={statusFilter === "approved"}
              />
              <label htmlFor="refund_approved">Approved</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="refund_rejected"
                name="refund"
                value="rejected"
                onChange={handleInputChange}
                checked={statusFilter === "rejected"}
              />
              <label htmlFor="refund_rejected">Rejected</label>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="l-col-100 u-padding-top-0 u-padding-bottom-0">
          <div className="filter-bar">
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="penalty_all"
                name="penalty"
                value="allStatus"
                onChange={handleInputChange}
                checked={statusFilter === "allStatus"}
              />
              <label htmlFor="penalty_all">All</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="penalty_pending"
                name="penalty"
                value="pending"
                onChange={handleInputChange}
                checked={statusFilter === "pending"}
              />
              <label htmlFor="penalty_pending">Pending</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="penalty_applied"
                name="penalty"
                value="not exempt"
                onChange={handleInputChange}
                checked={statusFilter === "not exempt"}
              />
              <label htmlFor="penalty_applied">Applied</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="penalty_waived"
                name="penalty"
                value="exempt"
                onChange={handleInputChange}
                checked={statusFilter === "exempt"}
              />
              <label htmlFor="penalty_waived">Waived</label>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="l-base-layout__content">
      <h1>Admin / Issues & Resolutions</h1>

      <div className="c-hr"></div>
      <div className="my-16">
        <div className="custom-tabs">
          <div
            className={`tab-item ${activeTab === "refund" ? "active" : ""}`}
            onClick={() => setActiveTab("refund")}
          >
            Refunds
            {/* <span className="badge">4</span> */}
          </div>
          <div
            className={`tab-item ${activeTab === "driverPenalties" ? "active" : ""
              }`}
            onClick={() => setActiveTab("driverPenalties")}
          >
            Driver Penalties
            {/* <span className="badge">9</span> */}
          </div>
        </div>
      </div>
      <div className="c-subheader-info-panel">
        {activeTab === "refund" && (
          <div className="c-subheader-info-panel__search">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                searchIssueAndResolution();
              }}
            >
              <input
                type="text"
                value={searchValue || ""}
                onChange={handleInputChange}
                name="search"
                placeholder="Search Refunds..."
                className="c-subheader-info-panel__input"
              />
              <button
                type="button"
                className="c-btn-outline c-btn-outline--white c-btn-outline--small"
                onClick={() =>
                  searchValue !== null && searchIssueAndResolution()
                }
              >
                Search
              </button>
            </form>
          </div>
        )}

        {activeTab === "driverPenalties" && (
          <div className="c-subheader-info-panel__search">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                searchIssueAndResolution();
              }}
            >
              <input
                type="text"
                value={searchValue || ""}
                onChange={handleInputChange}
                name="search"
                placeholder="Search Driver Penalties..."
                className="c-subheader-info-panel__input"
              />
              <button
                type="button"
                className="c-btn-outline c-btn-outline--white c-btn-outline--small"
                onClick={() =>
                  searchValue !== null && searchIssueAndResolution()
                }
              >
                Search
              </button>
            </form>
          </div>
        )}
      </div>

      <div className="my-16 text-end">
        {selectedCheckbox.length > 0 && (
          <button
            type="button"
            className="c-btn c-btn--red c-btn--small mb-0"
            onClick={handleDeleteSelected}
          >
            Delete Selected
          </button>
        )}
      </div>

      <div className="l-row">
        {renderFilterOptions()}

        <div className="l-col-100">
          <div className="c-hr u-margin-bottom-0"></div>

          {/* Column headers based on active tab */}
          {renderColumnHeaders()}

          <div>
            {issueResolutions?.length > 0 ? (
              issueResolutions?.map(renderIssueResolution)
            ) : (
              <div className="u-text-align-center u-margin-top-bottom-m u-color-red">
                No {activeTab === "refund" ? "Refunds" : "Driver Penalties"}{" "}
                found
              </div>
            )}
          </div>

          <div className="c-hr u-margin-bottom-0"></div>

          <Pagination
            pageSize={pageSize}
            totalPages={totalPages}
            page={page}
            setPage={setPage}
            inputValue={inputValue}
            setInputValue={setInputValue}
            setPageSize={setPageSize}
          />
        </div>
      </div>
    </div>
  );
};

IssuesResolution.propTypes = {
  userDetails: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
};

export default withNavigate(IssuesResolution);
